// extracted by mini-css-extract-plugin
module.exports = {"page":"_19851","main":"_16892"};